@import '../../styles/modals.css';
@import '../../styles/buttons.css';

main {
  padding: 20px 15px;
}

#tambr-message.no-backdrop {
  background: none;
}

.order-details-wrapper {
  border-top: 1px solid #d5d9de;
}